import type {State} from '../../reducers/types'
import {restApi} from '../../services/rest'
import type {RouteAvailabilityResponse} from '../../types'

export const getAvailabilityResponse = (
  state: State,
  path: string,
): RouteAvailabilityResponse | null | undefined =>
  state.routeAvailabilityResponse[path] ??
  restApi.endpoints.getRouteAvailability.select(path)(state)?.data
